import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import qs from "qs";
import {urlLogin} from "@/api/login";
import JSONBig from "json-bigint";
import store from "@/store/index";
Vue.use(VueRouter)
const routes=[{
    path: '/',
    redirect: '/home'
},
// 首页
{
    path: '/home',
    name: 'home',
    component: () =>
        import('@/views/home')
},
// 列表页
{
    path: '/listpage',
    name: 'listpage',
    component: () =>
        import('@/views/listpage')
},
// 登录页
{
    path: '/login',
    name: 'login',
    component: () =>
        import('@/views/login')
},
// 视频页
{
    path: '/videoPlay',
    name: 'videoPlay',
    component: () =>
        import('@/views/videoPlay')
},
// 地图页
{
    path: '/map',
    name: 'map',
    component: () =>
        import('@/views/map')
},
]


const router=new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to,from,next) => {
    if(to.path==='/login') {
        next()
        return
    }
    const customerId=Cookies.get('customerId');
    if(customerId) {
        next()
    } else {
        var tokenAuth=to.query.tokenAuth;
        var data=qs.stringify({
            tokenAuth: tokenAuth
        });
        // 链接登录
        urlLogin(data)
            .then((res) => {
                if(res.data.code==200) {
                    Cookies.set(
                        "customerData",
                        JSONBig.stringify(res.data.data)
                    );
                    Cookies.set("username",res.data.data.username);
                    Cookies.set("customerType",res.data.data.customerType);
                    Cookies.set("customerId",res.data.data.id);
                    router.push("/home");
                }
                if(res.data.code==500) {
                    store.commit("setMessage",res.data.message);
                    router.push("/login");

                }
                if(res.data.code==600) {
                    router.push("/login");
                }
            });
    }
})
export default router